export class AddToWaitlistWidgetSettings {
  public addToWaitListUrl: string;
}
